const messages = {
  name: 'Registro de Eventos de Credito |||| Registros de Eventos de Credito',
  fields: {
    costCenterName: 'Centro de Coste',
    account: 'Cuenta',
    provider: 'Proveedor',
    applicationName: 'Aplicacion',
    channel: 'Canal',
    from: 'Desde',
    to: 'Para',
    creditsConsumed: 'Creditos Consumidos',
    createdAt: 'Fecha de Registro',
  },
  empty: 'No hay registros de eventos',
  filters: {
    costCenterName: 'Centro de Coste',
    applicationName: 'Aplicacion',
    channel: 'Canal',
    from: 'Proveedor',
    to: 'Para',
  },
  search: {
    placeholder: 'Buscar Registros de Mensajes',
  },
};

export default messages;
